/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Title_LeadInputs */

const en_coaches_page_title_lead = /** @type {(inputs: Coaches_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A coach who`)
};

const pl_coaches_page_title_lead = /** @type {(inputs: Coaches_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener, który`)
};

/**
* | output |
* | --- |
* | "A coach who" |
*
* @param {Coaches_Page_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_title_lead = /** @type {((inputs?: Coaches_Page_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_title_lead(inputs)
	return en_coaches_page_title_lead(inputs)
});